import { useState } from 'react'

export default function useStateWithLocalStorage({ key, initialValue }) {
  const saved = JSON.parse(window.localStorage.getItem(key))
  const [state, setState] = useState(saved || initialValue)

  function setStateAndSave(newState) {
    setState(newState)
    window.localStorage.setItem(key, JSON.stringify(newState))
  }

  return [state, setStateAndSave]
}
